import { OptionItem } from 'tno-core';

export const directionOptions = [new OptionItem('Row', 'row'), new OptionItem('Column', 'column')];
